import { render, staticRenderFns } from "./ViewCard.vue?vue&type=template&id=539a3b10&scoped=true"
import script from "./ViewCard.vue?vue&type=script&lang=ts"
export * from "./ViewCard.vue?vue&type=script&lang=ts"
import style0 from "./ViewCard.vue?vue&type=style&index=0&id=539a3b10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "539a3b10",
  null
  
)

export default component.exports